module.exports = __webpack_public_path__ + "static/media/starter-incubator.24dd1542.jpg";